export default __webpack_public_path__ + "static/media/map_point.86f0cd0c.svg";